/*
 * View for the topic label modal
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicLabelModal/template/topicLabelModalTemplate.html",
], function (Marionette, TopicLabelModalTemplate) {
  "use strict";

  const TopicLabelModalView = {};

  TopicLabelModalView.topicLabelModalLayout = Marionette.Layout.extend({
    template: TopicLabelModalTemplate,
    regions: {
      labelList: "#labelListArea",
    },

    triggers: {
      "click #cancelButton": "cancel",
      "click #doneButton": "done",
      "change #touchPoints": "touchPoint:changed",
    },

    ui: {
      touchPoints: "#touchPoints",
    },

    addTouchPoint: function (touchPointName, touchPointId) {
      const o = new Option(touchPointName, touchPointId);
      this.ui.touchPoints.append(o);
    },
    getTouchPoint: function () {
      return parseInt(this.ui.touchPoints.children("option:selected").val(), 10);
    },
    clearTouchPoints: function () {
      this.ui.touchPoints.empty();
    },
  });

  return TopicLabelModalView;
});
